import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
const ExternalComponent = () => {
    const [countdown, setCountdown] = useState(5);
    const [targetUrl, setTargetUrl] = useState(null);
    const [cancelled, setCancelled] = useState(false);
    let interval = useRef(null);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const url = urlParams.get('url');
        if (!url) {
            console.error('URL parameter is missing');
            return;
        }
        const decodedUrl = decodeURIComponent(url);
        setTargetUrl(decodedUrl);
        interval.current = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    let intervalLocal = interval.current;
                    clearInterval(intervalLocal);
                    window.location.href = decodedUrl;
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    function cancel() {
        let intervalLocal = interval.current;
        clearInterval(intervalLocal);
        setCancelled(true);
    }
    if (!targetUrl) {
        return (_jsx("div", { className: "container", children: _jsxs("div", { className: "card", children: [_jsx("h2", { className: "errorTitle", children: "Error" }), _jsx("p", { className: "errorText", children: "URL is not specified" })] }) }));
    }
    return (_jsx("div", { className: "container", children: _jsx("div", { className: "card", children: cancelled ?
                _jsx("h1", { className: "title", children: "Cancelled" })
                :
                    (_jsxs(_Fragment, { children: [_jsx("h1", { className: "title", children: "Warning" }), _jsx("p", { className: "warningText", children: "You are being redirected to an external site. The site you are about to visit may not affiliated with us. Please proceed with caution." }), _jsx("div", { className: "countdown", children: countdown != -1 ? countdown : "" }), _jsxs("p", { className: "urlText", children: [_jsx("strong", { children: "Link:" }), " ", targetUrl] }), _jsx("button", { className: "cancelButton", onClick: () => cancel(), children: "Cancel" })] })) }) }));
};
export default ExternalComponent;
